<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="2">
        <v-select
          class="shared-source-fiscalYear"
          label="Fiscal Years"
          v-model="editedItem.fiscalYear"
          :items="fiscalYearRange"
        ></v-select>
      </v-col>
        <v-col cols="3">
          <v-text-field
            label="Unit Code"
            v-uppercase=globalSettingItem.conEverythingToCaps
            v-model="editedItem.unitCode"
          ></v-text-field>
        </v-col>
        <v-col col="3">
          <v-text-field
            label="Unit Code Number"
            v-uppercase=globalSettingItem.conEverythingToCaps
            v-model="editedItem.unitCodeNumber"
          ></v-text-field>
        </v-col>
        <v-col col="3">
          <v-text-field
            label="Description"
            v-uppercase=globalSettingItem.conEverythingToCaps
            v-model="editedItem.description"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import {
  getFYList,
} from '../../../util/shared/tmc-global';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';

export default {
  name: 'unitCodeCriteria',
  mixins: [GlobalToCaps],
  components: {
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'unitCodeDialog',
    },
  },
  created() {
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
    ]),
    ...mapState({
      fiscalYearRange: (state) => {
        const registerdYears = state.misc.schoolUnit.regYears || {};
        return getFYList(registerdYears);
      },
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setItem',
    ]),
  },
};
</script>
